var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3751_85105",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3751_85105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833984 17.5V13.3333H2.50065V15.8333H5.00065V17.5H0.833984ZM15.0007 17.5V15.8333H17.5007V13.3333H19.1673V17.5H15.0007ZM3.33398 15V5H5.00065V15H3.33398ZM5.83398 15V5H6.66732V15H5.83398ZM8.33398 15V5H10.0007V15H8.33398ZM10.834 15V5H13.334V15H10.834ZM14.1673 15V5H15.0007V15H14.1673ZM15.834 15V5H16.6673V15H15.834ZM0.833984 6.66667V2.5H5.00065V4.16667H2.50065V6.66667H0.833984ZM17.5007 6.66667V4.16667H15.0007V2.5H19.1673V6.66667H17.5007Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeScanner);
export default __webpack_public_path__ + "static/media/barcode-scanner.5e9bb953a60eae7ccf660cb80995b5a8.svg";
export { ForwardRef as ReactComponent };